import { render, staticRenderFns } from "./ModalEventChanges.vue?vue&type=template&id=664386e7&scoped=true&"
import script from "./ModalEventChanges.vue?vue&type=script&lang=js&"
export * from "./ModalEventChanges.vue?vue&type=script&lang=js&"
import style0 from "./ModalEventChanges.vue?vue&type=style&index=0&id=664386e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664386e7",
  null
  
)

export default component.exports